<template>
    <div class="container-fluid">
        <div class="row">
            <FormAnnualServiceFeeDetail />
            <!-- <TableHistoryAnnualServiceFee /> -->
        </div>
    </div>
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue'

const FormAnnualServiceFeeDetail = defineAsyncComponent(() => import("@/components/theme/annual-service-fee/FormAnnualServiceFeeDetail.vue"))
const TableHistoryAnnualServiceFee = defineAsyncComponent(() => import("@/components/theme/annual-service-fee/TableHistoryAnnualServiceFee.vue"))
</script>